import apiSlice from "./ApiSlice";

const courseTypeApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllCourseTypeData: builder.query({
            providesTags: ["course-type"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/course-type",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteCourseTypeById: builder.mutation({
            invalidatesTags: ["course-type"],
            query: (id: any) => ({
                url: `/course-type/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addCourseType: builder.mutation({
            invalidatesTags: ["course-type"],
            query: (body) => ({
                url: `/course-type/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getCourseTypeById: builder.query({
            providesTags: ["course-type"],
            query: (id: string) => {
                return {
                    url: `/course-type/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateCourseTypeById: builder.mutation({
            invalidatesTags: ["course-type"],
            query: ({ body, id }) => ({
                url: `/course-type/${id}`,
                method: "PUT",
                body,
            }),
        }),

        //get Course
        getAllCourseType : builder.query({
            providesTags: ["course-type"],
            query: () => {
                return {
                    url: `/course-type`,
                    method: "GET",
                };
            },
        }),

        // change status of delivery date
        changeStatusCourseTypeById: builder.mutation({
            invalidatesTags: ["course-type"],
            query: ({ body, id }) => ({
                url: `/course-type/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllCourseTypeDataQuery,
    useDeleteCourseTypeByIdMutation,
    useAddCourseTypeMutation,
    useGetAllCourseTypeQuery,
    useGetCourseTypeByIdQuery,
    useUpdateCourseTypeByIdMutation,
    useChangeStatusCourseTypeByIdMutation,
} = courseTypeApi;
